export const MAX_MOBILE_WIDTH = 767;
export const MAX_TABLET_WIDTH = 1024;
